import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  const loc = useLocation();

  if (!checked || user === null) {
    return <div className="min-h-screen bg-obsidian flex items-center justify-center text-[#828290] font-mono text-sm">Authenticating…</div>;
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  }
  return children;
}
